import React from 'react'
import ReactDOM from 'react-dom'
import { platform } from '../device/platform'
import { initGlobalVariables } from './initializers/global-variables';
import initMicrofrontendsDiscovery from './initializers/discovery';
import initMobile from './mobile';
import getMemoryToken from '../session/token';
import { IPreInit } from '../../interfaces/App/IPreInit';
import readModulesFromDevice from '../versions/read-modules';
import initializeSentry from './initializers/initializeSentry';
import { FileSystem } from '../filesystem/index';
import { renderAuraSplash } from '../../../application/components/Splash/native';
import { clearServiceWorker } from './initializers/service-worker';
import { redirectBasename } from './services/redirect-basename';
import validateEmptyScreen from './services/validateEmptyScreen';

redirectBasename()
renderAuraSplash()
validateEmptyScreen(20) // validacion si en 20 segundos desde aqui no existe contenido en root, se cierra la sesion

export const filesystem = platform !== 'web' ? new FileSystem() : undefined;
// ARMAR REDUCER DEL CONNECTED
// CON ESO AGREGAR UN CUSTOMHOOK AL MOBILEAPP QUE TRATE DE SINCRONIZAR AL CAMBIAR LA CONECTIVIDAD

export default async function preInit (): Promise<IPreInit> {

  if ( typeof TRACKING_ACTIVATED !== 'undefined' && TRACKING_ACTIVATED === 'true' ) initializeSentry()

  if ( filesystem !== undefined ) await filesystem.init();
  const initialToken = await getMemoryToken()
  const microfrontendsResponse = await initMicrofrontendsDiscovery( initialToken )

  if ( platform !== 'web' ){
    await initMobile( microfrontendsResponse )
  } else {
    await clearServiceWorker()
  }

  const memoryModules = await readModulesFromDevice()

  initGlobalVariables({
    microfronts: microfrontendsResponse.microFrontends, 
    initialToken,
    memoryModules
  })

  return {
    discoveredMicrofronts: microfrontendsResponse.microFrontends,
    initialToken,
    memoryModules
  }

}
